import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

export const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
});

// Register the router type for type-safe routing throughout the app.
declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}
